module.exports = __webpack_public_path__ + "assets/ic_menu2.ce36372f.svg";